import React from 'react'
import { Modal } from 'bootstrap'
import request from "../../api/request";

const LoginButton = () => {
  const [modal, setModal] = React.useState(null)
  const [isResponseError, setResponseError] = React.useState(false)
  const exampleModal = React.useRef()

  const openModal = () => {
    modal.show()
  }

  const hideModal = () => {
    modal.hide()
  }

  React.useEffect(() => {
    setModal(
      new Modal(exampleModal.current)
    )
  }, [])

  const onSubmit = e => {
    e.preventDefault()
    const formData = {}
    Array.from(e.currentTarget.elements).forEach(el => {
      const name = el.getAttribute('name')
      if(name === 'remember') {
        formData[name] = el.checked
      } else {
        formData[name] = el.value
      }
    })
    request.post('api/privacy-policy/ui/login', formData)
      .then(function (response) {
        if(response.data.error) {
          setResponseError(true)
        } else {
          hideModal()
        }
      })
      .catch(function (error) {
        console.log(error, 'error');
      })
  }

  return (
    <>
      <button
        type='button'
        className='btn btn-primary me-2'
        onClick={openModal}
      >
        <i className="fas fa-sign-in-alt fs-4 me-2"/>
        Sign in
      </button>
      <div className="modal fade" ref={exampleModal} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">Sign in</h5>
              <button type="button" className="btn-close" onClick={hideModal} aria-label="Close" />
            </div>
            <div className="modal-body">
              {isResponseError &&
                <p className='text-danger'>Invalid username or password</p>
              }
              <form onSubmit={onSubmit}>
                <div className="mb-5">
                  <label htmlFor="username" className="form-label required">Username</label>
                  <input id="username" type="text" name='username' required={true} autoFocus={true} className="form-control"/>
                </div>

                <div className="mb-5">
                  <label htmlFor="password" className="form-label required">Password</label>
                  <input id="password" type="password" name="password" required={true} className="form-control"/>
                </div>
                <div className="mb-5">
                  <div className="form-check form-check-custom form-check-solid">
                    <input name="remember" className="form-check-input" type="checkbox" value="" id="remember"/>
                    <label className="form-check-label" htmlFor="remember">
                      Remember me
                    </label>
                  </div>
                </div>

                <div className="d-flex justify-content-center">
                  <button type="submit" className="btn btn-success login-inner-modal-button">LOG IN</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default LoginButton